/**
 * Build a URL query string from a plain object.
 *
 * - Skips entries whose value is undefined, null, or '' (after String() coerce).
 * - Coerces numbers/booleans to strings.
 * - Array values produce repeated keys: { tag: ['a','b'] } -> "tag=a&tag=b".
 * - Returns the string WITHOUT a leading '?'. Empty input returns ''.
 *
 * Usage:
 *   `/api/foo?${buildQuery({ limit: 100, status })}`
 *   withQuery('/api/foo', { limit: 100, status })   // adds '?' only if needed
 */
export function buildQuery(params) {
  if (!params || typeof params !== 'object') {
    return '';
  }

  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null) {
      continue;
    }
    if (Array.isArray(value)) {
      for (const item of value) {
        if (item === undefined || item === null) continue;
        const str = String(item);
        if (str === '') continue;
        search.append(key, str);
      }
      continue;
    }
    const str = String(value);
    if (str === '') {
      continue;
    }
    search.set(key, str);
  }

  return search.toString();
}

export function withQuery(path, params) {
  const qs = buildQuery(params);
  return qs ? `${path}?${qs}` : path;
}
